import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../../utills/utils";

import Spinner from "../../Modals/SpinnerModal";
import Modal from "../../Modals/CancelModal";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  display: flex;
  flex-flow: wrap;
`;

const Shop = styled.div`
  width: 43%;
  height: 180px;
  background: yellow;
  margin: 0 2% 2% 0;
  background: white;
  border: 1px solid #eee;
  padding: 2%;
`;
const ShopTitle = styled.h3`
  font-weight: 500;
  margin: 0;
  padding: 5px 0;
`;
const SecondTitle = styled.p`
  margin: 0;
  padding: 3px 0;
  color: gray;
`;
const Button1 = styled.button`
  width: 48.5%;
  padding: 10px;
  margin: 5px 5% 0 0;
  font-size: 1em;
  background: #ff5d5d;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;
const Button2 = styled.button`
  width: 45%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
`;
const CancelTitle = styled.p``;
const ShopItem = (props) => {
  return (
    <Shop>
      <ShopTitle>{props.shop.name}</ShopTitle>
      <SecondTitle>{props.shop.categoryName}</SecondTitle>
      <SecondTitle>{props.shop.phone}</SecondTitle>
      <SecondTitle>{props.shop.email}</SecondTitle>
      <SecondTitle>
        {props.shop.cityName},{props.shop.thanaName}
      </SecondTitle>
      <Button1
        onClick={() => {
          props.blockModaHandler(props.shop._id);
        }}
      >
        Active
      </Button1>
      {/* <Button2 onClick={() => props.cancelModaHandler(props.shop._id)}>
        Cancel
      </Button2> */}
    </Shop>
  );
};

function BlockShops() {
  const [shops, setShops] = useState([]);
  const [complete, setComplete] = useState(false);
  const [block, setBlock] = useState(false);
  const [blockId, setBlockId] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const fetchShops = async (args, req) => {
    try {
      const shops = await axios.post(server, {
        query: `
                    query{
                        bannedShops{
                          _id
                          name
                          phone
                          email
                          location
                          cityName
                          thanaName
                          categoryName
                        }
                    }
                  `,
      });
      setShops(shops.data.data.bannedShops);
      setComplete(true);
    } catch (error) {
      throw error;
    }
  };

  const shopBlockHandler = async (shopId) => {
    try {
      setBlock(false);
      setSpinner(true);
      const shop = await axios.post(server, {
        query: `
                    mutation{
                        onBoardBannedShop(shopId:"${shopId}"){
                          _id
                          name
                          phone
                          email
                          location
                          cityName
                          thanaName
                          categoryName
                        }
                    }
                  `,
      });
      // setShops(shop.data.data.bannedShop);
      const updatedShops = shops.filter((shop) => {
        return shop._id !== shopId;
      });
      setShops(updatedShops);
      setSpinner(false);
    } catch (error) {
      throw error;
    }
  };

  const blockModaHandler = (id) => {
    setBlock(true);
    setBlockId(id);
  };
  const blockCloseHandler = () => {
    setBlock(false);
    setBlockId(null);
  };

  useEffect(() => {
    fetchShops();
  }, []);
  return (
    <div>
      <Spinner show={spinner} />

      <Modal show={block} closeModal={blockCloseHandler}>
        <CancelTitle>Are you sure want to active this shop again ?</CancelTitle>
        <Button1
          onClick={() => {
            shopBlockHandler(blockId);
          }}
        >
          Yes
        </Button1>
        <Button2 onClick={blockCloseHandler}>No</Button2>
      </Modal>

      {complete ? (
        <Container>
          {shops.map((shop) => {
            return (
              <ShopItem
                blockModaHandler={blockModaHandler}
                key={shop._id}
                shop={shop}
              />
            );
          })}
        </Container>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default BlockShops;
